import { useApiClient } from '@chilipiper/api-client/src/context'
import { useQuery } from '@tanstack/react-query'

export const useRoundRobinSchedulingLink = (tenantId: string, id = '') => {
  const { teamScheduling } = useApiClient()
  return useQuery({
    queryKey: ['round-robin-scheduling-link', tenantId, id],
    queryFn: () =>
      teamScheduling.findARoundRobinSchedulingLinkByRoundRobinSchedulingLinkIdPublic(tenantId, id),
    enabled: Boolean(id),
  })
}
